// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  line-height: 1.5;
}

.h6,
h6 {
  font-size: 0.875rem;
}

.birth-date {
  font-family: Poppins, sans-serif !important;
  font-size: 46px;
  margin-top: -15px;
  font-weight: 100 !important;
}

.card {
  margin-bottom: 1rem;
  background-color: var(--foreground-secondary) !important;
  border-radius: 7px !important;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.birthday-page .card {
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5) !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.birthDay-contain,
.dashboard-page .card,
.floating-labels select.form-control > option {
  background: var(--foreground-secondary);
  border-radius: 7px !important;
}

.birthDay-contain .btn-birthDaysubmit {
  margin: 15px 0;
}

.birthDay-contain .card-body {
  padding: 0.2rem 1.25rem;
}

.birthDay-contain h5.c2lbiz-ae-steps-body-title {
  margin-top: 6px;
}

.birthDay-contain h5 {
  margin-bottom: 0;
}

.p-2 {
  padding: 0.5rem !important;
}

.row {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
}

.card .card-title {
  position: relative;
  font-weight: 500;
  color: coral;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.iconClass {
  color: grey;
}

.messages_noData {
  padding-bottom: 30px;
  line-height: 0.5 !important;
}

.nodataclass {
  width: 40%;
  height: 425px;
  margin: 20px;
}

@media only screen and (max-width: 900px) {
  .nodataclass {
    width: 80%;
    height: 425px;
    margin: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/Notifications/birth-day-reminders/birth-day-reminders.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,2CAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AACF;;AAEA;EACE,mBAAA;EACA,wDAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,qDAAA;EACA,oCAAA;AACF;;AAEA;;;EAGE,uCAAA;EACA,6BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AACA;EACE,gBAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;AAEF;;AACA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,oBAAA;EACA,2BAAA;AAEF;;AACA;EACE,UAAA;EACA,aAAA;EACA,YAAA;AAEF;;AACA;EACE;IACE,UAAA;IACA,aAAA;IACA,YAAA;EAEF;AACF","sourcesContent":["* {\r\n  line-height: 1.5;\r\n}\r\n\r\n.h6,\r\nh6 {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.birth-date {\r\n  font-family: Poppins, sans-serif !important;\r\n  font-size: 46px;\r\n  margin-top: -15px;\r\n  font-weight: 100 !important;\r\n}\r\n\r\n.card {\r\n  margin-bottom: 1rem;\r\n  background-color: var(--foreground-secondary) !important;\r\n  border-radius: 7px !important;\r\n}\r\n\r\n.card-body {\r\n  flex: 1 1 auto;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.birthday-page .card {\r\n  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.5) !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.birthDay-contain,\r\n.dashboard-page .card,\r\n.floating-labels select.form-control > option {\r\n  background: var(--foreground-secondary);\r\n  border-radius: 7px !important;\r\n}\r\n\r\n.birthDay-contain .btn-birthDaysubmit {\r\n  margin: 15px 0;\r\n}\r\n\r\n.birthDay-contain .card-body {\r\n  padding: 0.2rem 1.25rem;\r\n}\r\n\r\n.birthDay-contain h5.c2lbiz-ae-steps-body-title {\r\n  margin-top: 6px;\r\n}\r\n.birthDay-contain h5 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.p-2 {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n.row {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.card .card-title {\r\n  position: relative;\r\n  font-weight: 500;\r\n  color: coral;\r\n}\r\n\r\n.text-truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.iconClass {\r\n  color: grey;\r\n}\r\n\r\n.messages_noData {\r\n  padding-bottom: 30px;\r\n  line-height: 0.5 !important;\r\n}\r\n\r\n.nodataclass {\r\n  width: 40%;\r\n  height: 425px;\r\n  margin: 20px;\r\n}\r\n\r\n@media only screen and (max-width: 900px) {\r\n  .nodataclass {\r\n    width: 80%;\r\n    height: 425px;\r\n    margin: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
